import React, { useEffect } from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
//import ReactPlayer from "react-player/youtube";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
//import MKSocialButton from "components/MKSocialButton";

import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";
//import FilledInfoCard from "examples/Cards/InfoCards/FilledInfoCard";

import Counters from "pages/inicio/sections/Counters";
import Information from "pages/inicio/sections/Information";
//import DesignBlocks from "pages/inicio/sections/DesignBlocks";
import Pages from "pages/inicio/sections/Pages";
import Objetivos from "pages/inicio/sections/data/Objetivos";

import BuiltByDevelopers from "pages/inicio/components/BuiltByDevelopers";

import routes from "routes";
import footerRoutes from "footer.routes";

import bgImage from "assets/images/quadroNegro.jpg";

function inicio() {
  useEffect(() => {
    console.clear();
  }, []);

  return (
    <>
      <DefaultNavbar routes={routes} sticky />
      <MKBox
        minHeight="75vh"
        width="100%"
        sx={{
          backgroundImage: `url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "top",
          display: "grid",
          placeItems: "center",
        }}
      >
        <Container>
          <Grid container item xs={12} lg={10} justifyContent="center" mx="auto">
            <MKTypography
              variant="h1"
              color="white"
              textAlign="center"
              mt={-2}
              mb={1}
              sx={({ breakpoints }) => ({
                fontSize: "3.5rem",
                lineHeight: 1.2,
                [breakpoints.down("md")]: {
                  fontSize: "2.5rem",
                },
                [breakpoints.down("sm")]: {
                  fontSize: "2rem",
                },
              })}
            >
              Modelagem na Educação Matemática Inclusiva
            </MKTypography>
            <MKTypography
              variant="body1"
              color="white"
              textAlign="center"
              fontSize="25px"
              px={{ xs: 6, lg: 12 }}
              mt={1}
            >
              Estamos aqui para tornar a matemática acessível para todos.
            </MKTypography>
          </Grid>
        </Container>
      </MKBox>
      <Card
        sx={{
          p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <Counters />
        <Information />
        <Objetivos />
        <Pages />
        <Container sx={{ mt: 6 }}>
          <BuiltByDevelopers />
        </Container>
        <MKBox pt={18} pb={6}>
          <Container>
            <Grid container spacing={3}>
              <Grid item xs={12} lg={5} ml="auto" sx={{ textAlign: { xs: "center", lg: "left" } }}>
                <MKTypography variant="body2" fontWeight="bold" mb={0.5}>
                  Educação Matemática; Site educacional; Inclusão. Contribuir com a construção de
                  práticas pedagógicas que atendam alunos surdos e ouvintes.
                </MKTypography>
              </Grid>
              <Grid
                item
                xs={12}
                lg={5}
                my={{ xs: 5, lg: "auto" }}
                mr={{ xs: 0, lg: "auto" }}
                sx={{ textAlign: { xs: "center", lg: "right" } }}
              ></Grid>
            </Grid>
          </Container>
        </MKBox>
      </Card>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default inicio;
